import { h } from '@stencil/core'

import { ExternalLink } from '../utils/url'

export const GetFathomBadge = () => (
  <ExternalLink class='group text-info-warn' href='https://fathom.video/'>
    <aside class='flex items-center'>
      <svg viewBox='0 0 15.9 25' class='h-5 opacity-10 group-hover:opacity-100 transition duration-200 fill-current'>
        <path d='M0,12.5l14.35,12h0A2.48,2.48,0,0,0,15.9,25V0a2.48,2.48,0,0,0-1.52.53h0Z' />
      </svg>
      <span class='flex items-center pr-7px h-5 text-base font-bold group-hover:text-surface-base bg-info-warn bg-opacity-10 group-hover:bg-opacity-100 rounded-r transition duration-200'>
        Get your own free AI Notetaker 🔥
      </span>
    </aside>
  </ExternalLink>
)
